import API from './Api';

class QuickNotesAPI extends API {
  constructor() {
    super('/quick-notes');
  }

}

export default QuickNotesAPI;